export function createTrustedInteractionScope() {
  let current = null;
  let timer = null;

  function beginTrustedInteraction(reason, ttlMs = 15000) {
    current = { reason, startedAt: Date.now() };
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      current = null;
    }, ttlMs);
    return () => endTrustedInteraction();
  }

  function endTrustedInteraction() {
    current = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function isTrusted() {
    return current != null;
  }

  function getReason() {
    return current && current.reason;
  }

  return { beginTrustedInteraction, endTrustedInteraction, isTrusted, getReason };
}
